var tabIndex = Object.freeze({
   Disabled: -1,
   DomOrder: 0
});

export default tabIndex;
